module.exports = __webpack_public_path__ + "img/7.fec76915.jpg";